import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useEffect, useState } from "react";
import { PaymentConfirmationView } from "./ui/view";
import { useDispatch } from "react-redux";
import { quoteOne } from "../../store/generateQuote/actions";
import { getCustomerAction } from "../../fnx/customer";
import { PaymentConfirmationHeader } from "./ui/header";
import { useGetSteps } from "../../utils/getSteps";
import { policyConfirm, policyConfirmClearData, } from "../../store/policy/actions";
import { useNavigate } from "react-router-dom";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { getDataFormFilters } from "./resources/paymentConfirmationDTO";
import { showErrorToast } from "../../fnx/showError";
import { useTranslation } from "react-i18next";
import { STEP_PAYMENTCONFIRMATION } from "../../const/catalog";
import { formatToTwoDecimals } from "../../utils/getPrice";
import useSelectors from "./components/selectors";
import useUI from "./components/ui";
import usePaymentConfirmation from "./components/paymentConfirmation";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
var PaymentConfirmation = function () {
    var dispatch = useDispatch();
    var STEP = STEP_PAYMENTCONFIRMATION;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var steps2 = useGetSteps();
    var _a = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _a[0], setSeeToast = _a[1];
    var _b = useState(true), showModal = _b[0], setShowModal = _b[1];
    var _c = useState([]), certificates = _c[0], setCertificates = _c[1];
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quoteId = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var Policy = React.useState(findParamInLocalStorage("Policy"))[0];
    var policyId = Policy === null || Policy === void 0 ? void 0 : Policy.id;
    var company = React.useState(findParamInLocalStorage("subdomain"))[0];
    var User = React.useState(findParamInLocalStorage("user"))[0];
    // const email = User?.email;
    var _d = useState(""), email = _d[0], setEmail = _d[1];
    var _e = useState({}), dataForm = _e[0], setDataForm = _e[1];
    var _f = useSelectors(), responseQuote = _f.responseQuote, responseOneQuote = _f.responseOneQuote, responsePolicyConfirm = _f.responsePolicyConfirm, responsePolicyConfirmError = _f.responsePolicyConfirmError, responsePolicyConfirmLoading = _f.responsePolicyConfirmLoading, errorOneQuote = _f.errorOneQuote;
    var _g = useUI(STEP, navigate, showModal, setShowModal, responseOneQuote), showSuccess = _g.showSuccess, handlePrevious = _g.handlePrevious, handleNext = _g.handleNext, handleDownload = _g.handleDownload;
    var handleSendEmail = usePaymentConfirmation(policyId, dispatch, policyConfirm).handleSendEmail;
    useEffect(function () {
        dispatch(quoteOne({ id: quoteId, fullBody: true }));
    }, []);
    useEffect(function () {
        if (errorOneQuote) {
            showErrorToast(errorOneQuote, setSeeToast, t);
        }
    }, [errorOneQuote]);
    useEffect(function () {
        if (responsePolicyConfirmError) {
            showErrorToast(responsePolicyConfirmError, setSeeToast, t);
        }
    }, [responsePolicyConfirmError]);
    useEffect(function () {
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            var certs = responseOneQuote.data.certificates;
            if (certs.length > 0) {
                certs = certs.map(function (c, id) {
                    return {
                        id: c.id,
                        name: c.title,
                        url: c.url,
                    };
                });
            }
            setCertificates(certs);
        }
    }, [responseOneQuote]);
    useEffect(function () {
        if (responsePolicyConfirm && (responsePolicyConfirm === null || responsePolicyConfirm === void 0 ? void 0 : responsePolicyConfirm.data)) {
            setSeeToast({
                show: true,
                message: "Correo enviado con éxito",
                type: typeAlert.success,
            });
            dispatch(policyConfirmClearData());
        }
    }, [responsePolicyConfirm]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        if ((responseQuote === null || responseQuote === void 0 ? void 0 : responseQuote.data) || (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            var df = dataForm;
            df.Name = responseOneQuote
                ? "".concat((_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.firstNameA, " ").concat((_b = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _b === void 0 ? void 0 : _b.firstNameB)
                : "".concat(responseQuote.data.firstNameA, " ").concat(responseQuote.data.firstNameB);
            df.LastNames = responseOneQuote
                ? "".concat((_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.lastNameA, " ").concat((_d = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _d === void 0 ? void 0 : _d.lastNameB)
                : "".concat(responseQuote.data.lastNameA, " ").concat(responseQuote.data.lastNameB);
            df.DocumentNumber = responseOneQuote
                ? "".concat((_e = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _e === void 0 ? void 0 : _e.numberId)
                : "".concat(responseQuote.data.numberId);
            df.Insurance = responseOneQuote
                ? "".concat((_g = (_f = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _f === void 0 ? void 0 : _f.productId) === null || _g === void 0 ? void 0 : _g.description)
                : "".concat(responseQuote.data.productId.description);
            df.PlanTypeName = responseOneQuote
                ? "".concat((_j = (_h = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _h === void 0 ? void 0 : _h.planId) === null || _j === void 0 ? void 0 : _j.name)
                : "".concat(responseQuote.data.planId.name);
            df.CampaignName = responseOneQuote
                ? responseOneQuote &&
                    "".concat((_m = (_l = (_k = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _k === void 0 ? void 0 : _k.productId) === null || _l === void 0 ? void 0 : _l.campaign[0]) === null || _m === void 0 ? void 0 : _m.name)
                : "".concat(responseQuote.data.productId.campaign[0].name);
            df.CoverType = (_q = (_p = (_o = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _o === void 0 ? void 0 : _o.coverType) === null || _p === void 0 ? void 0 : _p.description) !== null && _q !== void 0 ? _q : "";
            df.PaymentMode = responseOneQuote
                ? "".concat((_s = (_r = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _r === void 0 ? void 0 : _r.catalogPaymentMode) === null || _s === void 0 ? void 0 : _s.description)
                : "".concat(responseQuote.data.catalogPaymentMode.description);
            df.Currency = getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")
                ? (_t = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data.lastPrice) === null || _t === void 0 ? void 0 : _t.currencySymbol
                : (_u = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _u === void 0 ? void 0 : _u.planId.price.currencySymbol;
            df.Prima = getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")
                ? ((_v = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data.lastPrice) === null || _v === void 0 ? void 0 : _v.amount)
                    ? formatToTwoDecimals(responseOneQuote.data.lastPrice.amount)
                    : "0.00"
                : (_w = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _w === void 0 ? void 0 : _w.planId.price.amount;
            df.QuoteId = responseOneQuote
                ? "".concat((_x = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _x === void 0 ? void 0 : _x.id)
                : "".concat(responseQuote.data.id);
            setDataForm(df);
            setEmail((_z = (_y = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _y === void 0 ? void 0 : _y.email) !== null && _z !== void 0 ? _z : "");
            setInterval(function () {
                setShowModal(false);
            }, 5000);
        }
    }, [responseQuote, responseOneQuote]);
    return (_jsxs(React.Fragment, { children: [_jsx(PaymentConfirmationHeader, { steps: steps2, responsePolicyConfirmLoading: responsePolicyConfirmLoading, seeToast: seeToast, setSeeToast: setSeeToast }), showModal && showSuccess(), _jsx(PaymentConfirmationView
            // steps={steps}
            , { 
                // steps={steps}
                responsePolicyConfirmLoading: responsePolicyConfirmLoading, seeToast: seeToast, setSeeToast: setSeeToast, previousLabel: "Ver p\u00F3lizas", title: "Pago", onNext: handleNext, nextLabel: "Finalizar", section1Title: "Descarga de documentos", section2Title: "Enviar por correo", dataForm: dataForm, defaultEmail: email, 
                // stepProgress={steps}
                documents: certificates, filters: getDataFormFilters(dataForm), onBack: handlePrevious, onClickSendEmail: handleSendEmail, onClickDownload: handleDownload })] }));
};
export default PaymentConfirmation;
